<div class="header_search">
  <div class="title-page">
    <h3>{{type ? 'Cronogramas' : 'Documentos'}}</h3>
  </div>
  <div class="content_search">
    <div class="new-project" *ngIf="permission?.canCreateDoc">
      <a type="button" class="btn btn-primary btn" [routerLink]="novo()">Novo</a>
    </div>
  </div>
</div>

<div class="system-table table-container" *ngIf="permission?.canSeeDoc">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Título</th>
          <th>Descrição</th>
          <th>Tipo Documento</th>
          <th>Arquivo</th>
          <th>Responsável</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let documento of documentoList; let i = index">
          <tr>
            <td class="title"><span class="title-span">{{ documento?.title }}</span></td>
            <td>{{ documento?.description }}</td>
            <td>{{ documento?.type_name }}</td>
            <td>
              <p (click)="download(documento)" class="download">{{ documento?.name }}</p>
            </td>
            <td>{{ documento?.user }}
              <div>{{ documento?.created_at }}</div>
            </td>
            <td class="btn-icon-td">
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="editar(documento)" *ngIf="permission?.canEditDoc">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!documentoList?.length" class="border-b-radius">
          <td colspan="6" class="text-center">Nenhum Documento Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="hr-line-dashed"></div>
<div class="form-group row d-flex justify-content-end">
  <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
    <button class="btn btn-danger m-r-xxl" *ngIf="idProjeto && permission?.canDeleteProj" (click)="confirmExcluir()" type="button">Excluir</button>
    <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
    <button class="btn btn-white m-r-xs" *ngIf="idProjeto" type="button" (click)="imprimir()">Imprimir</button>
    <button class="btn btn-white m-r-xs" *ngIf="idProjeto && permission?.canCloneProj" type="button" (click)="openCloneModal()">Clonar</button>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>

<ng-template #modalClone>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Clonar processo</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeCloneModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Novo Nome</label>
        <input class="form-control" [(ngModel)]="clone_title" maxlength="300">
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-xxl-8 col-lg-10 col-sm-12 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeCloneModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!clone_title" (click)="clonar()">Clonar</button>
      </div>
    </div>
  </div>
</ng-template>